import { ROUTES } from 'config/constants';
import {
  getPostLoginRouteForUser,
  isPlatformAdministrator,
  isPlatformAdminRoute,
} from 'utils/platformAdmin';

interface ReLoginData {
  id?: string;
  groups?: string[];
}

export function createLoginRedirectUrl(
  pathname: string,
  search: string,
  reLoginData?: ReLoginData,
): string {
  const { id, groups = [] } = reLoginData || {};

  const params = new URLSearchParams();

  params.set('redirectUrl', `${pathname}${search}`);

  if (groups && groups.length > 0) {
    params.set('userGroups', JSON.stringify(groups));
  }

  if (id) {
    params.set('userId', id);
  }

  return `${ROUTES.LOGIN}?${params.toString()}`;
}

function getRedirectPathname(redirectUrl: string): string {
  return redirectUrl.split('?')[0].split('#')[0] || '/';
}

export function processLoginRedirect(
  redirectUrl: string | undefined,
  userGroups: string | undefined,
  userId: string | undefined,
  currentAuthInfo: ReLoginData | undefined,
  historyPush: (path: string) => void,
): void {
  const home = getPostLoginRouteForUser(currentAuthInfo?.groups);
  const isAdmin = isPlatformAdministrator(currentAuthInfo?.groups);

  if (!redirectUrl) {
    historyPush(home);
    return;
  }

  const redirectIsAdminRoute = isPlatformAdminRoute(
    getRedirectPathname(redirectUrl),
  );

  if (isAdmin !== redirectIsAdminRoute) {
    historyPush(home);
    return;
  }

  // if these additional verification props are not present, skip verification
  if (!userGroups || !userId) {
    historyPush(redirectUrl);
    return;
  }

  const { id: currentUserId, groups: currentGroups = [] } =
    currentAuthInfo || {};

  if (!currentUserId || !currentGroups || currentGroups.length === 0) {
    historyPush(getPostLoginRouteForUser(currentGroups));
    return;
  }

  try {
    const currentUserGroups = JSON.stringify(currentGroups.sort());
    const savedUserGroups = decodeURIComponent(userGroups);
    const savedUserId = decodeURIComponent(userId);

    if (
      currentUserId === savedUserId &&
      currentUserGroups === savedUserGroups
    ) {
      historyPush(redirectUrl);
    } else {
      historyPush(getPostLoginRouteForUser(currentGroups));
    }
  } catch (error) {
    console.warn('Error processing login redirect:', error);
    historyPush(getPostLoginRouteForUser(currentAuthInfo?.groups));
  }
}
